
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.725 15.18c.86.869 1.66.862 2.522 0l1.053-1.045a.46.46 0 01.348-.144h1.477c1.224 0 1.791-.56 1.791-1.79v-1.477a.46.46 0 01.144-.349l1.039-1.053c.875-.861.868-1.66 0-2.522l-1.04-1.053a.445.445 0 01-.143-.342V3.922c0-1.217-.56-1.791-1.791-1.791h-1.477a.453.453 0 01-.348-.137L9.247.948C8.386.08 7.586.087 6.725.948L5.672 1.994a.439.439 0 01-.342.137H3.847c-1.224 0-1.791.56-1.791 1.79v1.484c0 .137-.035.24-.137.342L.873 6.8c-.868.861-.861 1.66 0 2.522l1.046 1.053c.102.11.137.205.137.349V12.2c0 1.224.567 1.791 1.79 1.791H5.33c.137 0 .24.041.342.144l1.053 1.046zm.109-3.677c-.212 0-.349-.068-.451-.185L4.1 8.782a.591.591 0 01-.15-.39c0-.32.245-.56.594-.56a.57.57 0 01.444.191L6.8 10.026l3.52-4.956c.137-.198.274-.28.513-.28.335 0 .574.246.574.567a.678.678 0 01-.123.363L7.3 11.29a.57.57 0 01-.465.212z","fill":"#175F69"}})])
          )
        }
      }
    